import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { browserHistory } from 'react-router'
import { BootstrapTable, TableHeaderColumn, defaultSortName, defaultSortOrder, sizePerPage, sizePerPageList } from 'react-bootstrap-table'
import {
  Breadcrumb,
  Button,
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  InputGroup,
  MenuItem,
  Modal,
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap'
import { Editor } from 'react-draft-wysiwyg'
import { convertFromRaw, convertToRaw, EditorState, ContentState, convertFromHTML } from 'draft-js'
import Loadable from 'react-loading-overlay'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'

import Collapsible from '../collapsible'
import Dropdown from '../dropdown'
import Validators from '../../utils/validators'

@observer(['activities', 'companies', 'contacts', 'globals'])

export default class Notes extends Component {
  constructor(props) {
    super(props)

    let companyId = this.props.companyId
    let showEditNoteModal = false

    if (this.props.noteId > 0) {
      showEditNoteModal = true;
      this.openEditNoteModal(this.props.noteId)
    }

    this.state = {
      showEmailNoteModal: false,
      editModalTitle: 'Edit Notes',
      notes: '',
      showDetailsModal: false,
      showNewNoteModal: false,
      showEditNoteModal: false,
      newNote: '',
      editorContent: null,
      emailNoteNoteId: 0,
      emailAddress: '',
      loadableState: true
      //emailNoteContactId: 0
    }

    this.loadNotes(companyId)
  }

  loadNotes(companyId) {
    this.props.companies.loadCompanyNotes(companyId, () => {
      this.setState({
        loadableState: false
      })
    })
  }

  save(e) {
    this.props.companies.updateNote({
      id: document.getElementById('noteId').value,
      note: document.getElementById('editNote').value,
      hash: localStorage.getItem('userHash')
    })

    this.close()
  }

  open(e, id) {
    console.log(e)

    this.props.companies.loadNote(id, localStorage.getItem('userHash'), (data) => {
      document.getElementById('noteId').value = data.id
      document.getElementById('editNote').value = data.note
    })

    this.setState({
      showDetailsModal: true
    })
  }

  close() {
    this.setState({
      showDetailsModal: false
    })
  }

  openNewNoteModal() {
    /*
    let blocksFromHtml = convertFromHTML('')
    console.log('blocksFromHtml: ', blocksFromHtml)
    if (blocksFromHtml) {
      const state = ContentState.createFromBlockArray(
        blocksFromHtml.contentBlocks,
        blocksFromHtml.entityMap
      )
      const editorState = EditorState.createWithContent(state)

      this.setState({
        editorState: editorState
      })

      console.log('yes')
    } else {
      console.log('no')
    }
    */
    this.setState({
      editorState: ''
    })

    this.setState({
      showNewNoteModal: true
    })

  }

  closeNewNoteModal() {
    this.setState({
      showNewNoteModal: false
    })
  }

  openEditNoteModal(id) {
    this.props.companies.loadNote(id, (data) => {
      console.log('Data: ', data)
      try {
        const note = JSON.parse(data.note)
        console.log('Note: ', note)
        this.setState({
          showEditNoteModal: true
        }, () => {
          this.setState({
            editNoteId: id,
            editNoteContentState: note,
          });
        });
      } catch (e) {
        console.log('E: ', e)
        const blocksFromHtml = convertFromHTML(data.note)
        const state = ContentState.createFromBlockArray(
          blocksFromHtml.contentBlocks,
          blocksFromHtml.entityMap
        )
        const editorState = EditorState.createWithContent(state)

        this.setState({
          showEditNoteModal: true
        }, () => {
          this.setState({
            editNoteId: id,
            editNoteEditorState: editorState,
          });
        });
      }
    })
  }

  closeEditNoteModal() {
    this.setState({
      showEditNoteModal: false
    })
  }

  openEmailNoteModal(id) {
    this.setState({
      emailNoteNoteId: id,
      showEmailNoteModal: true
    })

    /*
    // Keep this in case Nick ever wants to add it back!!!
    this.props.contacts.loadAllContactsByCompany(this.props.companyId, (data) => {
      this.setState({
        emailNoteNoteId: id,
        emailNoteContactId: this.props.defaultContactId,
        showEmailNoteModal: true
      })
    })
    */
  }

  closeEmailNoteModal() {
    this.setState({
      // Keep this in case Nick ever wants to add it back!!!
      emailNoteNoteId: 0,
      //emailNoteContactId: 0,
      emailAddress: '',
      showEmailNoteModal: false
    })

  }

  newNoteValidationState() {
    if (this.state.newNote) {
      return 'success'
    } else {
      return 'error'
    }
  }

  cleanNoteToJSON(note) {
    console.log('RAW')
    console.log(note)

    const clean = note
      .replace(/\\n/g, '\\\\n')
      .replace(/\\r/g, '\\\\r')
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"')
      .replace(/\t/g, "   ")

      //      .replace(/'/g, "\\'")

    console.log('CLEAN')
    console.log(clean)

    return clean
  }

  newNote(row) {
    const cleanNote = this.cleanNoteToJSON(JSON.stringify(convertToRaw(this.state.editorState.getCurrentContent())))

    this.props.companies.addNote({
      note: cleanNote,
      companyId: this.props.companyId,
      userId: this.props.globals.loggedInUser.id,
      hash: localStorage.getItem('userHash')
    }, (data) => {
      this.props.companies.loadCompanyNotes(this.props.companyId)
      //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
      this.props.activities.logNewActivity(localStorage.getItem('userId'), 'create', 3, data.addNote.id, 1, this.props.companyId)
    })

    this.closeNewNoteModal()
  }

  editNote() {
    let cleanNote = this.cleanNoteToJSON(JSON.stringify(convertToRaw(this.state.editNoteEditorState.getCurrentContent())))

    this.props.companies.updateNote({
      id: this.state.editNoteId,
      note: cleanNote
    }, (data) => {
      this.props.companies.loadCompanyNotes(this.props.companyId)
      //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
      this.props.activities.logNewActivity(localStorage.getItem('userId'), 'update', 3, this.state.editNoteId, 1, this.props.companyId)
    })

    this.closeEditNoteModal()
  }

  onNoteChanged(state) {
    console.log(state)
    this.setState({
      editorState: state
    })
  }

  onEditNoteChanged(state) {
    this.setState({
      editNoteEditorState: state
    })
  }

  onEmailAddressChanged(e) {
    this.setState({
      emailAddress: e.target.value
    })
  }

  /*
  // Keep this in case Nick ever wants to add it back!!!
  onEmailNoteContactIdChanged(e) {
    this.setState({
      emailNoteContactId: e.target.value
    })
  }
  */

  updateNote(row, cell) {
    this.props.companies.updateNote({
      id: row.id,
      note: row.note,
      hash: localStorage.getItem('userHash')
    })
  }

  deleteNote(id) {
    if (confirm("Are you sure you want to delete this note?")) {
      this.props.companies.deleteNote(id, this.props.companyId, localStorage.getItem('userHash'))
      //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
      this.props.activities.logNewActivity(localStorage.getItem('userId'), 'delete', 3, id, 1, this.props.companyId)
    }
  }

  emailNote(row) {    
    if (confirm('Are you sure you want to send this note?  This action cannot be undone!')) {
      const params = {
        noteId: this.state.emailNoteNoteId,
        emailAddress: this.state.emailAddress
      }

      this.props.companies.emailNote(params, (data) => {
        alert('Email sent!')
        this.setState({
          showEmailNoteModal: false
        })
      })
    } else {
      alert('Action cancelled.')
    }

    /*
    // Keep this in case Nick ever wants to add it back!!!
    if (confirm('Are you sure you want to send this note?  This action cannot be undone!')) {
      const params = {
        noteId: this.state.emailNoteNoteId,
        contactId: this.state.emailNoteContactId
      }

      this.props.companies.emailNote(params, (data) => {
        alert('Email sent!')
        this.setState({
          showEmailNoteModal: false
        })
      })
    } else {
      alert('Action cancelled.')
    }
    */
  }

  formatNote(cell, row) {

    let note = '';

    try {
      note = draftToHtml(JSON.parse(cell))
    } catch(e) {
      console.log('Could not parse note JSON')
      note = cell
    }

    return note
  }

  formatActions(cell, row) {
    return (<div>
      <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'editNote-' + cell}>Edit Note</Tooltip> }><Button bsSize="small" bsStyle="warning" onClick={ (e) => { this.openEditNoteModal(cell) } }><i className="fa fa-pencil" aria-hidden="true"></i></Button></OverlayTrigger>
      <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'emailNote-' + cell}>Email Note</Tooltip> }><Button bsSize="small" bsStyle="primary" id={row.id} onClick={() => { this.openEmailNoteModal(cell) }}><i className="fa fa-envelope" aria-hidden="true"></i></Button></OverlayTrigger>
      <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'deleteNote-' + cell}>Delete Note</Tooltip> }><Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deleteNote(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button></OverlayTrigger>
    </div>)
  }

  sortByCreatedDate(a, b, order) {
    const aa = a.formattedCreatedDate.split('-')
    const bb = b.formattedCreatedDate.split('-')

    return this.sortByDate(aa, bb, order)
  }

  sortByDueDate(a, b, order) {
    const aa = a.formattedDueDate.split('-')
    const bb = b.formattedDueDate.split('-')

    return this.sortByDate(aa, bb, order)
  }

  sortByDate(aa, bb, order) {
    const fa = aa[2] + aa[0] + aa[1]
    const fb = bb[2] + bb[0] + bb[1]

    if (order == 'desc') {
      return fb - fa
    } else {
      return fa - fb
    }
  }

  render() {

    const options = {
      defaultSortName: 'id',  // default sort column name
      defaultSortOrder: 'desc',  // default sort order
      sizePerPage: 5,
      sizePerPageList: [ 5, 15, 25, 50 ]
    }

    const notesTable = (
      <div>
        <Button bsStyle="info" onClick={this.openNewNoteModal.bind(this)}><i className="fa fa-plus" aria-hidden="true"></i> New</Button>
        <BootstrapTable
            data={ this.props.companies.notes }
            striped={ true }
            hover={ true }
            pagination={ true }
            search={ true }
            options={ options }
            bordered={ false }
            >
          <TableHeaderColumn width="50" dataField="id" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
          <TableHeaderColumn width="100" dataField="formattedCreatedDate" sortFunc={ this.sortByCreatedDate.bind(this) } dataSort={ true } editable={ false }>Created Date</TableHeaderColumn>
          <TableHeaderColumn width="150" dataField="note" dataFormat={ this.formatNote.bind(this) } dataSort={ true }>Note</TableHeaderColumn>
          <TableHeaderColumn width="150" dataField="userFullName" editable={ false } hiddenOnInsert={ true } dataSort={ true }>Created By</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
        </BootstrapTable>
      </div>
    )

    return (
      <div>
        <Loadable active={ this.state.loadableState } spinner text='Processing your request...'>
          <div>
            { /* <Collapsible title="Notes" content={ notesTable } /> */ }
            { notesTable }
          </div>
        </Loadable>
        <div style={{ clear: 'both' }}></div>
        <Modal show={ this.state.showNewNoteModal } onHide={ this.closeNewNoteModal.bind(this) }>
          <Modal.Header closeButton>
            <Modal.Title>New Note</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal name="newNoteForm">
              <FormGroup>
                <Col sm={ 6 }>
                  <Editor toolbarHidden editorState={ this.state.editorState } onEditorStateChange={ this.onNoteChanged.bind(this) } wrapperStyle={{ border: '1px solid #ccc', height: '300px', width: '550px' }} />
                </Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={ this.closeNewNoteModal.bind(this) }><i className="fa fa-times" aria-hidden="true"></i> Cancel</Button>
            <Button bsStyle="success" onClick={ this.newNote.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={ this.state.showEditNoteModal } onHide={ this.closeEditNoteModal.bind(this) }>
          <Modal.Header closeButton>
            <Modal.Title>Edit Note</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal name="editNoteForm">
              <FormGroup>
                <Col sm={ 6 }>
                  <Editor toolbarHidden contentState={ this.state.editNoteContentState } editorState={ this.state.editNoteEditorState } onEditorStateChange={ this.onEditNoteChanged.bind(this) } wrapperStyle={{ border: '1px solid #ccc', height: '300px', width: '550px' }} />
                </Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={ this.closeEditNoteModal.bind(this) }><i className="fa fa-times" aria-hidden="true"></i> Cancel</Button>
            <Button bsStyle="success" onClick={ this.editNote.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={ this.state.showDetailsModal } onHide={ this.close.bind(this) }>
          <Modal.Header closeButton>
            <Modal.Title>{ this.state.editModalTitle }</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal name="newPartnerForm">
              <FormGroup>
                <Col componentClass={ ControlLabel } sm={ 2 }>Notes:</Col>
                <input type="hidden" id="noteId" />
                <Col sm={ 8 }><FormControl componentClass="textarea" id="editNote" /></Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={ () => { this.close() } }><i className="fa fa-ban" aria-hidden="true"></i> Cancel</Button>
            <Button bsStyle="success" onClick={ (e) => { this.save(e) } }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={ this.state.showEmailNoteModal } onHide={ this.closeEmailNoteModal.bind(this) }>
          <Modal.Header closeButton>
            <Modal.Title>Email Note</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal name="emailNoteForm">
              <FormGroup>
                <Col componentClass={ ControlLabel } sm={ 4 }>Select Email:</Col>
                <Col sm={ 8 }><FormControl type="text" placeholder="Email" id="emailAddress" onChange={this.onEmailAddressChanged.bind(this)} /></Col>
                { /* <Col sm={ 8 }><Dropdown data={this.props.contacts.contacts.map((contact) => ({id: contact.id, name: contact.fullName + ' - ' + contact.email}))} defaultValue={this.state.defaultContactId} onChange={this.onEmailNoteContactIdChanged.bind(this)} /></Col> */ }
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={ () => { this.closeEmailNoteModal() } }><i className="fa fa-ban" aria-hidden="true"></i> Cancel</Button>
            <Button bsStyle="success" onClick={ (e) => { this.emailNote(e) } }><i className="fa fa-floppy-o" aria-hidden="true"></i> Send Note</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/company/notes.js